export enum PaymentErrorsEnum {
  INSUFFICIENT_AMOUNT = 'insufficientAmount',
  TRANSACTION_ERROR = 'transactionError',
  TRANSACTION = 'transaction',
  ANTIFRAUD = 'antifraud',
  EXPIRED = 'expired',
}

export const enum PaymentErrorPathsEnum {
  ORDER_ID = 'orderId',
  SALE_ID = 'saleId',
  DIRECT_LINK_ID = 'directLinkId',
  PAYMENT_ID = 'paymentId',
}

export const checkInsufficientAmountError = (errors: { [key: string]: string[] }) => {
  const errorPaths = [
    PaymentErrorPathsEnum.ORDER_ID,
    PaymentErrorPathsEnum.SALE_ID,
    PaymentErrorPathsEnum.DIRECT_LINK_ID,
    PaymentErrorPathsEnum.PAYMENT_ID,
  ];

  const orderIdErrors = errorPaths
    .map((path) => errors?.[path])
    .flat()
    .filter(Boolean);

  return orderIdErrors.some((error) => error === PaymentErrorsEnum.INSUFFICIENT_AMOUNT);
};
